import { Link } from "react-router-dom";
import { FooterSection } from "../../landing-page/sections/FooterSection";
import { Header } from "../../landing-page/sections/headerSection";
import "./LegalNoticePage.scss";

const legalSections = [
  {
    id: "editeur",
    title: "Editeur du site",
    content: [
      "La Plateforme Nationale d'Interopérabilité est éditée par l'Agence des Systèmes d'Information et du Numérique (ASIN), établissement public chargé de la mise en oeuvre et de l'exploitation des plateformes numériques de l'administration béninoise.",
      "Adresse: 01 BP 8088 Cotonou, Bénin, Avenue Steinmetz, quartier Tokpa Hoho. Téléphone: +229 01 21 30 78 50 / 65.",
      "Le directeur de publication est le Directeur Général de l'ASIN.",
    ],
  },
  {
    id: "objet",
    title: "Objet de la plateforme",
    content: [
      "La plateforme accompagne les structures publiques dans la création, la gestion, la consultation et la mise à jour des référentiels de l'Etat béninois.",
      "Elle facilite la coordination inter-administrative, la gouvernance des données et l'interopérabilité des systèmes d'information publics.",
    ],
  },
  {
    id: "acces",
    title: "Accès aux services",
    content: [
      "L'accès à certaines fonctionnalités peut nécessiter une authentification et l'attribution de droits par l'administration de la plateforme.",
      "Les frais d'accès à internet, d'équipement ou de communication restent à la charge de l'utilisateur.",
      "La plateforme peut être interrompue temporairement pour maintenance, évolution technique ou impératif de sécurité.",
    ],
  },
  {
    id: "responsabilites",
    title: "Responsabilités",
    content: [
      "L'utilisateur est responsable de l'utilisation de son compte, de ses identifiants et des opérations réalisées depuis son espace.",
      "Les informations saisies ou importées dans les référentiels doivent être exactes, licites et conformes aux autorisations dont dispose l'utilisateur.",
      "L'ASIN met en oeuvre les moyens nécessaires pour assurer la disponibilité, la sécurité et la confidentialité de la plateforme, sans pouvoir être tenue responsable des cas de force majeure, des interruptions externes ou de l'usage non autorisé des accès.",
    ],
  },
  {
    id: "propriete-intellectuelle",
    title: "Propriété intellectuelle",
    content: [
      "Les textes, logos, interfaces, éléments graphiques, documents, bases de données et autres contenus accessibles sur ce site sont protégés par la réglementation applicable au Bénin en matière de propriété intellectuelle.",
      "Toute reproduction, adaptation, diffusion ou exploitation commerciale d'un contenu du site nécessite une autorisation préalable de l'ASIN ou du titulaire des droits concernés.",
    ],
  },
  {
    id: "donnees-personnelles",
    title: "Données personnelles",
    content: [
      "Les données traitées peuvent notamment concerner l'identité des utilisateurs, leurs coordonnées professionnelles, leurs habilitations, les traces d'opérations, les données de référentiels et les pièces nécessaires au fonctionnement des services.",
      "Ces données sont utilisées pour l'administration des comptes, la sécurité, l'assistance, la traçabilité, la gestion des référentiels et l'interopérabilité entre systèmes publics.",
      "Les données personnelles sont conservées pour la durée nécessaire aux finalités du traitement, aux obligations légales et aux besoins de preuve ou de sécurité.",
      "L'ASIN ne vend pas les données personnelles. Elles peuvent être accessibles aux services habilités de l'ASIN, aux structures publiques concernées ou aux autorités légalement compétentes.",
    ],
  },
  {
    id: "droits",
    title: "Droits des personnes concernées",
    content: [
      "Conformément au Code du numérique en République du Bénin, toute personne concernée peut demander l'accès, l'interrogation, la rectification, la mise à jour, l'opposition, la suppression ou la réparation relative à ses données personnelles, selon les traitements concernés.",
      "Les demandes peuvent être adressées au Directeur Général de l'ASIN ou au Délégué à la Protection des Données par courrier électronique à protectiondesdonnees@asin.bj ou contact@asin.bj.",
      "Une réclamation peut également être adressée à l'Autorité de Protection des Données Personnelles (APDP) à l'adresse contact@apdp.bj.",
    ],
  },
  {
    id: "reclamations",
    title: "Réclamations",
    content: [
      "Toute demande relative à l'utilisation de la plateforme, à un accès, à un compte ou à une donnée doit être transmise au support ou à la structure responsable du service concerné.",
      "Lorsqu'une demande concerne un traitement de données personnelles, elle est instruite selon la procédure de gestion des droits prévue par l'ASIN.",
    ],
  },
];

export default function LegalNoticePage() {
  return (
    <>
      <Header />
      <main className="LegalNoticePage">
        <section className="LegalNoticePage-hero">
          <Link className="LegalNoticePage-backLink" to="/">
            Retour à l'accueil
          </Link>
          <p className="LegalNoticePage-eyebrow">Informations légales</p>
          <h1 className="LegalNoticePage-title">Mentions légales</h1>
          <p className="LegalNoticePage-intro">
            Les présentes mentions encadrent l'édition, l'accès et l'utilisation de la Plateforme
            Nationale d'Interopérabilité dédiée à la gestion des référentiels de l'administration
            béninoise.
          </p>
        </section>

        <section className="LegalNoticePage-content" aria-label="Mentions légales">
          {legalSections.map((section) => (
            <article className="LegalNoticePage-section" id={section.id} key={section.title}>
              <h2 className="LegalNoticePage-sectionTitle">{section.title}</h2>
              {section.content.map((paragraph) => (
                <p className="LegalNoticePage-paragraph" key={paragraph}>
                  {paragraph}
                </p>
              ))}
            </article>
          ))}
        </section>
      </main>
      <FooterSection />
    </>
  );
}
